import moment from 'moment';

import { ShoppingCartService } from 'app/page/orders/service/shopping-cart-service';

interface Keys {
    cartAllMonthsKey: string;
    month: moment.Moment;
    monthKey: string;
    cartSingleMonthKey: string;
}

export class AvailableTimeProvider {
    private fetchedAvailableTime: Record<string, OrderTrackerBackend.DayTimeSlots[] | undefined> = {};

    public readonly fetchAndMergeAvailableTime = (
        partnerId: string,
        cartId: string,
        billingAccountId: string,
        servicePointId: string,
        date: moment.Moment,
    ): Promise<OrderTrackerBackend.DayTimeSlots[]> => {
        const keys: Keys = this.keys(partnerId, cartId, date);

        if (this.fetchedAvailableTime[keys.cartSingleMonthKey]) {
            return Promise.resolve(this.fetchedAvailableTime[keys.cartAllMonthsKey] || []);
        }

        this.fetchedAvailableTime[keys.cartSingleMonthKey] = [];
        return ShoppingCartService.getAvailableAppointmentTime(partnerId, billingAccountId, servicePointId, keys.month)
            .then((time) => {
                const mergedTime = [...(this.fetchedAvailableTime[keys.cartAllMonthsKey] || []), ...time];

                this.fetchedAvailableTime[keys.cartAllMonthsKey] = mergedTime;
                return mergedTime;
            })
            .catch((reason) => {
                this.fetchedAvailableTime[keys.cartSingleMonthKey] = undefined;
                return Promise.reject(reason);
            });
    };

    public readonly needsFetch = (partnerId: string, cartId: string, date: moment.Moment): boolean => {
        const keys: Keys = this.keys(partnerId, cartId, date);

        return !this.fetchedAvailableTime[keys.cartSingleMonthKey];
    };

    private readonly keys = (partnerId: string, cartId: string, date: moment.Moment): Keys => {
        const month: moment.Moment = date.clone().startOf('month');
        const monthKey: string = month.toISOString();
        const cartAllMonthsKey: string = `${partnerId}-${cartId}`;

        return {
            cartAllMonthsKey,
            month,
            monthKey,
            cartSingleMonthKey: `${cartAllMonthsKey}-${monthKey}`,
        };
    };
}
